import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';
import { UpdateUserReportPreferencesParams } from '@/api/requests/userReportPreferences';
import { useAppConfigContext } from '@/context/AppConfig';
import { AppRequests } from '@/context/AppRequests';

export const useUserReportPreferences = () => {
  const { updateUserReportPreferences } =
    useContext(AppRequests).UserReportPreferencesRequests;
  const { logError } = useAppConfigContext();
  const queryClient = useQueryClient();

  const updatePreferences = useMutation({
    mutationFn: (params: UpdateUserReportPreferencesParams) =>
      updateUserReportPreferences(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account'] });
    },
    onError: (error) => {
      logError('Update Report Preferences', error as Error);
    },
  });

  return {
    updatePreferences,
  };
};
